/**
 * Use this file for JavaScript code that you want to run in the front-end
 * on posts/pages that contain this block.
 *
 * When this file is defined as the value of the `viewScript` property
 * in `block.json` it will be enqueued on the front end of the site.
 *
 * Example:
 *
 * ```js
 * {
 *   "viewScript": "file:./view.js"
 * }
 * ```
 *
 * If you're not making any changes to this file because your project doesn't need any
 * JavaScript running in the front-end, then you should delete this file and remove
 * the `viewScript` property from `block.json`.
 *
 * @see https://developer.wordpress.org/block-editor/reference-guides/block-api/block-metadata/#view-script
 */

import { store, getContext } from '@wordpress/interactivity';

const { actions, state } = store( 'ev-blocks/ev-mega-menu', {
	callbacks: {
		isMenuOpen() {
			return state.openMenu == getContext().self;
		}
	},
	actions: {
		toggleMenu() {
			if (state.openMenu == getContext().self) {
				actions.closeMenu();
			} else {
				actions.openMenu();
			}
		},
		openMenu() {
			state.openMenu = getContext().self;
		},
		closeMenu() {
			if (state.openMenu == getContext().self) {
				state.openMenu = null;
			}
		},
		handleBodyClick(e) {
			if (e.target?.closest('a')) {
				// clicked on a link in the menu
				state.openMenu = null;
			}
		},
		handleTopKey(e) {
			if (!['Enter', 'Space'].includes(e.key) || state.openMenu == getContext().self) return;
			state.openMenu = getContext().self;
			e.preventDefault();
			// setTimeout(() => {
			// 	e.target.closest('li')?.querySelectorAll('a')[1]?.focus();
			// }, 1);
		},
		handleBodyKey(e) {
			if (e.key != 'Escape') return;
			e.target.closest('li')?.querySelector('a')?.focus();
			state.openMenu = null;
			e.preventDefault();
		},
	}
} );
